<template>
  <div class="add-client--container no-select">
    <fields-client
      :search="search"
      :reset="reset"
      :submit="submitAdd"
      @submit="addClient"
    ></fields-client>
    <div class="btn btn-sm btn-success" @click="addSubmit">Сохранить</div>
  </div>
</template>

<script>

import FieldsClient from "@/components/panel/clients/FieldsClient";
import clientsRepository from "../../../repositories/clients";

export default {
  name: "AddClient",
  components: { FieldsClient },
  data() {
    return {
      submitAdd: 0
    };
  },
  props: {
    search: String, // Строка поиска для отображения
    reset: Boolean // будем сбрасывать на false
  },
  watch: {},
  computed: {},
  methods: {
    addSubmit() {
      this.submitAdd++;
    },
    addClient(val) {
      this.$store.dispatch("startPreloader");

      const data = {};
      for (let key in val) {
        data[key] = val[key];
      }

      clientsRepository.add(data).then(resp => {
        this.$emit("addClient", resp.data);
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        if(err.response.data.code === 497){
          this.$emit('existsClient', val.number);
        }
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.add-client--form {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    width: 48%;
  }
}
.add-client--search {
  margin-bottom: 15px;
}
</style>
